{
  "de": {
    "milestone": {
      "actions": {
        "activate": "Aktivieren",
        "activate_phase": "Diese Phase aktivieren",
        "complete_phase": "Diese Phase abschließen",
        "create": "Phase erstellen",
        "delete": "Löschen",
        "delete_milestones": "Phase löschen | {count} Phasen löschen",
        "move_down": "Phase nach unten",
        "move_unit_back": "Einheit hierher zurücksetzen",
        "move_up": "Phase nach oben",
        "new": "Phase",
        "reactivate_phase": "Diese Phase reaktivieren"
      },
      "activate": {
        "body": "Alle Elemente dieser Phase werden für diese Einheit veröffentlicht und die Zuständigen erhalten eine Benachrichtigung.",
        "body_empty": "Macht nichts für den Kunden sichtbar.",
        "body_intermediate": "Dazwischenliegende Phasen werden mit abgeschlossen, und alle damit verknüpften Elemente werden ebenfalls veröffentlicht.",
        "body_project": "Alle Elemente dieser Phase werden für dieses Projekt veröffentlicht und die Zuständigen erhalten eine Benachrichtigung.",
        "body_reactivate": "Diese Phase wird wieder zur aktuellen Phase. Es wird nichts zurückgezogen: Alles, was bereits veröffentlicht oder versendet wurde, bleibt bestehen. Die Phasen danach werden wieder geplant.",
        "confirm": "Aktivieren",
        "confirm_publish": "Aktivieren und senden",
        "confirm_reactivate": "Reaktivieren",
        "past_warning": "Das Zurückgehen zu einer früheren Phase macht bereits Geschehenes nicht rückgängig. Mit Kunden geteilte Inhalte werden nicht automatisch zurückgezogen.",
        "title": "Phase aktivieren",
        "title_activate": "„{name}“ aktivieren?",
        "title_reactivate": "„{name}“ reaktivieren?",
        "verb_default": "Auslösen",
        "verb_share": "Teilen"
      },
      "assign": {
        "body": "Die ausgewählten Einheiten wechseln zu „{to}“. Die Elemente von „{to}“ und von jeder übersprungenen Phase werden für den Kunden sichtbar und die Zuständigen erhalten eine Benachrichtigung.",
        "body_phases_only": "Die ausgewählten Einheiten wechseln zu „{to}“. Der Kunde sieht die neue Phase.",
        "excluded": "Einheiten, die bereits in oder nach „{to}“ sind, können nicht ausgewählt werden."
      },
      "attach": {
        "add": "Hinzufügen",
        "add_and_move": "Hinzufügen und verschieben",
        "assigned_tag": "Zugewiesen",
        "back": "Zurück",
        "counts": "{available} verfügbar · {assigned} bereits zugewiesen",
        "description_decision": "Entscheidungen, die der Kunde treffen muss",
        "description_survey": "Fragebögen, um Feedback zu sammeln",
        "description_todo": "Aufgaben, die der Kunde erledigen muss",
        "elsewhere_tag": "Jetzt bei {name}",
        "empty": "Keine Elemente verfügbar",
        "empty_state_description": "Basierend auf Ihrem Plan können Sie {kinds} zu dieser Phase hinzufügen.",
        "intro": "Wählen Sie aus, welchen Elementtyp Sie mit dieser Phase verknüpfen möchten.",
        "move_notice_body": "Was bereits gesendet wurde, bleibt gesendet. Die bisherige Phase verliert dieses Element.",
        "move_notice_item": "{element}, jetzt bei {phase}",
        "move_notice_title": "Dieses Element wird nach „{name}“ verschoben | Diese Elemente werden nach „{name}“ verschoben",
        "next": "Weiter",
        "search": "Suche",
        "select_intro": "Wählen Sie die {kind} aus, die Sie hinzufügen möchten.",
        "subtitle": "Zur Phase: {name}",
        "success": "Elemente wurden hinzugefügt",
        "title": "Elemente hinzufügen"
      },
      "complete_phase": {
        "body": "Diese Einheit schließt diese Phase ab und hat danach keine aktive Phase mehr. | {count} Einheiten schließen diese Phase ab und haben danach keine aktive Phase mehr.",
        "body_sup": "Dieses Projekt schließt diese Phase ab und hat danach keine aktive Phase mehr.",
        "confirm": "Phase abschließen",
        "keep": "Phase aktiv lassen",
        "title": "“{name}” abschließen?"
      },
      "delete_phase": {
        "body": "Einheiten, die jetzt in dieser Phase sind, haben danach keine aktive Phase mehr. Sie gehen nicht zur vorherigen oder nächsten Phase. Die Elemente dieser Phase werden gelöst, nicht gelöscht. Elemente, die bereits für eine Einheit veröffentlicht wurden, bleiben veröffentlicht: Diese entfernen Sie bei der Einheit selbst.",
        "body_last": "Einheiten, die jetzt in dieser Phase sind, haben danach keine aktive Phase mehr. Da dies die letzte Phase ist, gelten sie dann als abgeschlossen. Die Elemente dieser Phase werden gelöst, nicht gelöscht. Elemente, die bereits für eine Einheit veröffentlicht wurden, bleiben veröffentlicht: Diese entfernen Sie bei der Einheit selbst.",
        "body_sup": "Dieses Projekt hat danach keine aktive Phase mehr. Es geht nicht zur vorherigen oder nächsten Phase. Die Elemente dieser Phase werden gelöst, nicht gelöscht. Bereits veröffentlichte Elemente bleiben veröffentlicht: Diese entfernen Sie beim Projekt selbst.",
        "confirm": "Phase löschen",
        "keep": "Phase behalten",
        "title": "„{name}“ löschen?"
      },
      "detach": {
        "body": "Damit wird das Element von dieser Phase gelöst. Das Element selbst bleibt bestehen und Einheiten, die es bereits gesehen haben, behalten es. Neue Einheiten erhalten es bei dieser Phase nicht mehr.",
        "confirm": "Lösen",
        "keep": "Behalten",
        "title": "„{name}“ lösen?"
      },
      "filters": {
        "clear": "Alle Filter zurücksetzen",
        "done": "Fertig",
        "group_milestones": "Phasen",
        "group_status": "Status",
        "group_title": "Inhalt der Phase",
        "no_phase": "Keine Phase",
        "no_units_here": "Keine Einheiten hier",
        "nothing_assigned": "Nichts zugewiesen",
        "phase_last": "In letzter Phase",
        "since_month_over": "Länger als ein Monat",
        "since_quarter_over": "Länger als 3 Monate",
        "since_two_weeks_over": "Länger als 2 Wochen",
        "title": "Filter",
        "units_here": "Hat Einheiten hier"
      },
      "labels": {
        "add_element": "Element hinzufügen",
        "added_ago": "Vor {duration} hinzugefügt",
        "assign_units": "Einheiten zuweisen",
        "assigned_count": "0 zugewiesen | 1 zugewiesen | {count} zugewiesen",
        "assigned_elements": "Zugewiesene Elemente",
        "assigned_empty_description": "{kinds} mit dieser Phase verknüpfen",
        "assigned_empty_title": "Noch keine Elemente",
        "bulk_assign_title": "Wählen Sie die Einheiten aus, denen Sie die Phase „{milestone_name}“ zuweisen möchten",
        "complete_units": "{count} Einheit abschließen | {count} Einheiten abschließen",
        "completed_subtitle": "Diese Einheiten haben den Workflow durchlaufen",
        "completed_title": "Abgeschlossen",
        "detach": "Lösen",
        "detach_element": "{name} lösen",
        "drag_to_reorder": "Zum Umsortieren ziehen",
        "edit_milestone": "Phase bearbeiten",
        "element_count": "{count} Element | {count} Elemente",
        "elements_assign_link": "Elemente in Meilensteinen zuweisen",
        "elements_empty": "Dieser Phase sind noch keine Elemente zugewiesen.",
        "elements_visible": "{elements} für den Kunden sichtbar",
        "empty_state_subtitle": "Phasen machen den Bauprozess für Käufer transparenter",
        "empty_state_title": "Neue Phase erstellen",
        "kind_decision": "Entscheidung | Entscheidungen",
        "kind_decision_count": "{count} Entscheidung | {count} Entscheidungen",
        "kind_survey": "Umfrage | Umfragen",
        "kind_survey_count": "{count} Umfrage | {count} Umfragen",
        "kind_todo": "Aufgabe | Aufgaben",
        "kind_todo_count": "{count} Aufgabe | {count} Aufgaben",
        "locked_not_sent": "{count} Element ist durch Ihr Paket gesperrt und wird nicht gesendet. | {count} Elemente sind durch Ihr Paket gesperrt und werden nicht gesendet.",
        "locked_tooltip": "Nicht in Ihrem aktuellen Paket enthalten. Dies wird nicht an Kunden gesendet.",
        "milestone": "Phase",
        "milestone_current": "Aktuelle Phase",
        "milestone_name": "Phasenname",
        "move_units_to": "{count} Einheit nach {name} verschieben | {count} Einheiten nach {name} verschieben",
        "new_milestone": "Neue Phase",
        "no_phase": "Keine Phase",
        "no_results": "Keine Phasen gefunden",
        "please_select": "Bitte wählen Sie eine neue Phase aus",
        "position": "Position",
        "progress": "Fortschritt",
        "publishes_empty": "Noch nichts zugewiesen",
        "publishes_summary": "Macht {elements} für den Kunden sichtbar",
        "reorder_filtered": "Suche oder Filter löschen, um Phasen umzusortieren",
        "search_empty_state": "Noch keine Phasen erstellt. Klicken Sie hier, um zu beginnen",
        "search_phase": "Phase suchen",
        "search_unit": "Einheit suchen",
        "search_units": "Einheiten suchen",
        "since": "Seit",
        "started_on": "Gestartet am {date}",
        "status_active": "In Bearbeitung",
        "status_completed": "Abgeschlossen",
        "status_planned": "Geplant",
        "unit_active_since": "Läuft seit {date}",
        "unit_completed_on": "Abgeschlossen {date}",
        "unit_timeline_empty": "Für dieses Projekt wurden noch keine Phasen erstellt.",
        "units": "Einheiten",
        "units_completed": "Keine Einheiten abgeschlossen | 1 Einheit abgeschlossen | {count} Einheiten abgeschlossen",
        "units_empty": "Noch keine Einheiten haben diese Phase erreicht.",
        "units_here": "Keine Einheiten hier | 1 Einheit hier | {count} Einheiten hier",
        "units_no_results": "Keine Einheiten gefunden",
        "units_without_milestone": "1 Einheit ohne Phase | {count} Einheiten ohne Phase",
        "unstarted_subtitle": "Diese Einheiten haben keine aktive Phase",
        "unstarted_title": "Nicht in einer Phase",
        "warning_delete": "Wenn Sie eine Phase löschen, die einer Einheit zugewiesen ist, verliert der Kunde den Überblick, in welcher Phase sich seine Einheit befindet. Achten Sie darauf, diesen Einheiten eine neue Phase zuzuweisen!"
      },
      "move": {
        "body": "Diese Einheit wechselt von „{from}“ zu „{to}“. Die Elemente von „{to}“ werden für den Kunden sichtbar und die Zuständigen erhalten eine Benachrichtigung. | Diese Einheiten wechseln von „{from}“ zu „{to}“. Die Elemente von „{to}“ werden für den Kunden sichtbar und die Zuständigen erhalten eine Benachrichtigung.",
        "body_phases_only": "Diese Einheit wechselt von „{from}“ zu „{to}“. Der Kunde sieht die neue Phase. | Diese Einheiten wechseln von „{from}“ zu „{to}“. Der Kunde sieht die neue Phase.",
        "confirm": "Verschieben und benachrichtigen",
        "confirm_phases_only": "Verschieben",
        "elements": "Macht {elements} für den Kunden sichtbar",
        "elements_empty": "Macht nichts für den Kunden sichtbar",
        "title": "{count} Einheit nach „{name}“ verschieben? | {count} Einheiten nach „{name}“ verschieben?"
      },
      "overview": {
        "no_phase": "Keine Phase",
        "not_started": "Nicht gestartet",
        "since_date": "Seit {date}",
        "step_of": "Schritt {step} von {total}"
      },
      "publication_failed": {
        "body": "Das Senden der Elemente dieser Phase ist für 1 Einheit fehlgeschlagen. | Das Senden der Elemente dieser Phase ist für {count} Einheiten fehlgeschlagen.",
        "retried": "Die Elemente werden erneut gesendet",
        "retry": "Erneut senden"
      },
      "reorder": {
        "body_earlier": "Wenn Sie diese Phase nach vorne verschieben, wird nichts zurückgezogen, was bereits veröffentlicht ist. Einheiten behalten, was sie haben; nur die Reihenfolge ändert sich.",
        "body_earlier_sup": "Wenn Sie diese Phase nach vorne verschieben, wird nichts zurückgezogen, was bereits veröffentlicht ist. Das Projekt behält, was es hat; nur die Reihenfolge ändert sich.",
        "body_later": "Wenn Sie diese Phase nach hinten verschieben, wird nichts zurückgezogen, was bereits veröffentlicht ist. Einheiten behalten, was sie haben; nur die Reihenfolge ändert sich.",
        "body_later_sup": "Wenn Sie diese Phase nach hinten verschieben, wird nichts zurückgezogen, was bereits veröffentlicht ist. Das Projekt behält, was es hat; nur die Reihenfolge ändert sich.",
        "body_passed": "Einheiten in einer späteren Phase durchlaufen diese Phase jetzt. Alles, was damit verknüpft ist, wird ihnen sofort veröffentlicht.",
        "body_passed_sup": "Dieses Projekt durchläuft diese Phase jetzt. Alles, was damit verknüpft ist, wird sofort veröffentlicht.",
        "body_passes": "Einheiten in dieser Phase durchlaufen die Phasen dazwischen jetzt. Alles, was mit diesen Phasen verknüpft ist, wird ihnen sofort veröffentlicht.",
        "body_passes_sup": "Dieses Projekt durchläuft die Phasen dazwischen jetzt. Alles, was mit diesen Phasen verknüpft ist, wird sofort veröffentlicht.",
        "confirm": "Phase verschieben",
        "count": "{count} Einheit durchläuft {phases} auf einmal | {count} Einheiten durchlaufen {phases} auf einmal",
        "count_sup": "Dieses Projekt durchläuft {phases} auf einmal",
        "crossed": "{name} ({elements})",
        "nothing": "nichts",
        "phases": "{count} Phase | {count} Phasen",
        "title": "„{name}“ nach „{previous}“ einordnen?",
        "title_first": "„{name}“ an den Anfang setzen?"
      },
      "toasts": {
        "bulk_assigned": "Die Phase wurde erfolgreich den ausgewählten Einheiten zugewiesen",
        "create_success": "Phase wurde erfolgreich erstellt",
        "deleted": "Phase gelöscht",
        "phase_without_units": "Keine Einheiten mehr in dieser Phase",
        "sup_assigned": "Die Phase wurde erfolgreich aktiviert",
        "sup_completed": "Phase abgeschlossen",
        "units_completed": "{count} Einheit abgeschlossen | {count} Einheiten abgeschlossen",
        "units_moved": "{count} Einheit verschoben | {count} Einheiten verschoben",
        "update_success": "Phasen wurden erfolgreich aktualisiert"
      },
      "validation": {
        "needName": "Name erforderlich",
        "needNamePrimary": "Der Name in der Primärsprache ({language}) ist erforderlich"
      }
    }
  }
}
